import instantsearch from 'instantsearch.js';
import {
  configure,
  hits,
  clearRefinements,
  refinementList,
  stats,
  pagination,
} from 'instantsearch.js/es/widgets';
import searchClient from './searchClient';
import SearchPage from './search-page';

function checkProp(){
  if (document.getElementById('data-check')) {
    const data = document.getElementById('data-check');
    if (data.hasAttribute('data-tags')){
      return true;
    } else { return false;}
  } else {
    return false;
  }
}

let containers = {};
const filter = document.getElementById('filters');

if (checkProp()) {
  containers = {
    stats: '#posts-search-stats',
    hitsContainer: '#posts-search-hits-container',
    hits: '#posts-search-hits',
    pagination: '#posts-search-pagination',
    refinementListSemester: '#posts-search-refinement-list-semester',
    refinementListCategories: '#posts-search-refinement-list-categories',
    refinementListTags: '#posts-search-refinement-list-tags',
    refinementListDepartments: '#posts-search-refinement-list-department',
    refinementListResearchCenters: '#posts-search-refinement-list-research-centers',
    refinementListTopics: '#posts-search-refinement-list-topics',
    clearRefinements: '#posts-search-clear-refinements',
  };
} else {
  containers = {
    stats: '#posts-search-stats',
    hitsContainer: '#posts-search-hits-container',
    hits: '#posts-search-hits',
    pagination: '#posts-search-pagination',
    refinementListSemester: '#posts-search-refinement-list-semester',
    refinementListCategories: '#posts-search-refinement-list-categories',
    refinementListDepartments: '#posts-search-refinement-list-department',
    refinementListResearchCenters: '#posts-search-refinement-list-research-centers',
    refinementListTopics: '#posts-search-refinement-list-topics',
    clearRefinements: '#posts-search-clear-refinements',
  };
}

class AlgoliaPostsSearch extends SearchPage {
  constructor(indexName, department = null, researchCenter = null, category = null, tags = null) {
    super(indexName);

    this.indexName = indexName;

    // Blog ID filter
    this.blogIdFilter =
      this.blogId !== 1
        ? ` AND (blog_id:1 OR blog_id:${this.blogId})`
        : `AND blog_id:${this.blogId}`;

    // Pre-filter parameters
    this.department = department;
    this.departmentFilter = this.department ? ` AND departments:"${this.department}"` : '';

    this.researchCenter = researchCenter;
    this.researchCenterFilter = this.researchCenter
      ? ` AND research_centers:"${this.researchCenter}"`
      : '';

    this.category = category.split('| ');
    this.categoryFilter = '';
    const cat_length = this.category.length;
    for (let i = 0; i < cat_length; i++) {
      this.categoryFilter += this.category[i] ? ` AND categories:"${this.category[i]}"` : '';
    }

    if (checkProp()){
      this.tags = tags.split('| ');
      this.tagsFilter = '';
      const tag_length = this.tags.length;
      for (let t = 0; t < tag_length; t++){
        this.tagsFilter += this.tags[t] ? ` AND tags:"${this.tags[t]}"` : '';
      }
    }

    this.hitsPerPage = 24;

    this.search = instantsearch({
      indexName: this.indexName,
      routing: true,
      searchClient,
      // https://www.algolia.com/doc/api-reference/widgets/instantsearch/js/#widget-param-searchfunction
      searchFunction: helper => {
        helper.search();
      },
    });

    this.initialize();
    this.search.start();
  }

  // Reverse chronologically sort Semesters
  sortSemesterRefinements(a, b) {
    const seasons = ['Fall', 'Summer', 'Spring'];
    const [seasonA, yearA] = a.name.split(' ');
    const [seasonB, yearB] = b.name.split(' ');

    // Return if year isn't a number
    if (isNaN(yearA) || isNaN(yearB)) {
      return 0;
    }

    if (yearA === yearB) {
      // Sort in order of seasons array
      return seasons.indexOf(seasonA) - seasons.indexOf(seasonB);
    } else {
      // Sort most recent year first
      return yearB - yearA;
    }
  }

  initialize() {
    if (checkProp()){
      // https://www.algolia.com/doc/api-reference/widgets/js/
      this.search.addWidgets([
        // https://www.algolia.com/doc/api-reference/widgets/configure/js/
        // Parameter options: https://www.algolia.com/doc/api-reference/search-api-parameters/
        configure({
          hitsPerPage: this.hitsPerPage,
          // Force faceting to be applied after de-duplication (via the Distinct setting)
          facetingAfterDistinct: true,
          // Filter the query with facet type of project
          // https://www.algolia.com/doc/api-reference/api-parameters/filters/#facet-filters
          filters: `(type:post)${this.blogIdFilter}${this.departmentFilter}${this.researchCenterFilter}${this.categoryFilter}${this.tagsFilter}`,
        }),

        // https://www.algolia.com/doc/api-reference/widgets/stats/js/
        stats({
          container: containers.stats,
          templates: {
            text: data => {
              let count = '';

              const pagination = document.querySelector(containers.pagination);
              this.toggleHide(pagination, data.nbHits <= this.hitsPerPage);

              if (data.hasManyResults) {
                count += `${data.nbHits} results found`;
              } else if (data.hasOneResult) {
                count += `1 result found`;
              } else {
                count += `<span class="search__stats-no-results">No results found.</span>`;
              }

              return `${count}`;
            },
          },
        }),

        // https://www.algolia.com/doc/api-reference/widgets/hits/js/
        hits({
          container: containers.hits,
          escapeHTML: false,
          templates: {
            /* eslint-disable */
            item(hit) {
              return `
              <a href="${hit.url}" class="hit-link">
                ${
                hit['featured_image']
                  ? `
                  <div class="hit-image">
                    <img class="" src="${hit['featured_image']}" alt="${hit.title}" />
                  </div>
                  `
                  : `
                  <div class="hit-placeholder-image-wrapper">
                    <div class="hit-placeholder-image">
                      <svg>
                        <use xlink:href="#ne-n"></use>
                      </svg>
                    </div>
                  </div>
                `
              }
                <h2 class="hit-title">
                  ${instantsearch.highlight({ attribute: 'title', hit })}
                </h2>
              </a>
            `;
            },
            /* eslint-enable */
          },
          transformItems: items => {
            // Hide pagination and results if no results
            this.toggleHide(this.results, items.length < 1);
            if (window.innerWidth <= 768 && items.length > 0) {
              this.toastActive();
            }
            return items;
          },
        }),

        // https://www.algolia.com/doc/api-reference/widgets/pagination/js/
        pagination({
          container: containers.pagination,
          showFirst: false,
          showLast: false,
          scrollTo: '.js--posts-search',
          templates: {
            previous: `
            <span class="visually-hidden">Previous page</span>
            <svg class="arrow prev">
              <use xlink:href="#icon-arrow"></use>
            </svg>
          `,
            next: `
            <span class="visually-hidden">Next page</span>
            <svg class="arrow next">
              <use xlink:href="#icon-arrow"></use>
            </svg>
          `,
          },
        }),

        // Semester
        refinementList({
          container: containers.refinementListSemester,
          attribute: 'semesters',
          operator: 'and',
          limit: 100, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.sortSemesterRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results or if department is specified
            const refList = document
              .querySelector(containers.refinementListSemester)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, items.length < 1);
            return items;
          },
        }),

        // Categories
        refinementList({
          container: containers.refinementListCategories,
          attribute: 'categories',
          operator: 'and',
          limit: 100, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.alphaSortRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results or if department is specified
            const refList = document
              .querySelector(containers.refinementListCategories)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, filter.getAttribute('data-cat-filter') !== 'true');
            return items;
          },
        }),

        // Tags
        refinementList({
          container: containers.refinementListTags,
          attribute: 'tags',
          operator: 'and',
          limit: 300, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.alphaSortRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results or if department is specified
            const refList = document
              .querySelector(containers.refinementListTags)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, filter.getAttribute('data-tag-filter') !== 'true');
            return items;
          },
        }),

        // School or Department
        refinementList({
          container: containers.refinementListDepartments,
          attribute: 'departments',
          operator: 'and',
          limit: 100, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.alphaSortRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results or if department is specified
            const refList = document
              .querySelector(containers.refinementListDepartments)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, filter.getAttribute('data-dept-filter') !== 'true');
            return items;
          },
        }),

        // Research Centers
        refinementList({
          container: containers.refinementListResearchCenters,
          attribute: 'research_centers',
          operator: 'and',
          limit: 100, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.alphaSortRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results or if research center is specified
            const refList = document
              .querySelector(containers.refinementListResearchCenters)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, filter.getAttribute('data-rc-filter') !== 'true');
            return items;
          },
        }),

        // Topics
        refinementList({
          container: containers.refinementListTopics,
          attribute: 'topics',
          operator: 'and',
          limit: 100, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.alphaSortRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results
            const refList = document
              .querySelector(containers.refinementListTopics)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, filter.getAttribute('data-topic-filter') !== 'true');
            return items;
          },
        }),

        // https://www.algolia.com/doc/api-reference/widgets/clear-refinements/js/
        clearRefinements({
          container: containers.clearRefinements,
          templates: {
            resetLabel: 'Clear filters',
          },
        }),
      ]);
    } else {
      // https://www.algolia.com/doc/api-reference/widgets/js/
      this.search.addWidgets([
        // https://www.algolia.com/doc/api-reference/widgets/configure/js/
        // Parameter options: https://www.algolia.com/doc/api-reference/search-api-parameters/
        configure({
          hitsPerPage: this.hitsPerPage,
          // Force faceting to be applied after de-duplication (via the Distinct setting)
          facetingAfterDistinct: true,
          // Filter the query with facet type of project
          // https://www.algolia.com/doc/api-reference/api-parameters/filters/#facet-filters
          filters: `(type:post)${this.blogIdFilter}${this.departmentFilter}${this.researchCenterFilter}${this.categoryFilter}`,
        }),

        // https://www.algolia.com/doc/api-reference/widgets/stats/js/
        stats({
          container: containers.stats,
          templates: {
            text: data => {
              let count = '';

              const pagination = document.querySelector(containers.pagination);
              this.toggleHide(pagination, data.nbHits <= this.hitsPerPage);

              if (data.hasManyResults) {
                count += `${data.nbHits} results found`;
              } else if (data.hasOneResult) {
                count += `1 result found`;
              } else {
                count += `<span class="search__stats-no-results">No results found.</span>`;
              }

              return `${count}`;
            },
          },
        }),

        // https://www.algolia.com/doc/api-reference/widgets/hits/js/
        hits({
          container: containers.hits,
          escapeHTML: false,
          templates: {
            /* eslint-disable */
            item(hit) {
              return `
              <a href="${hit.url}" class="hit-link">
                ${
                hit['featured_image']
                  ? `
                  <div class="hit-image">
                    <img class="" src="${hit['featured_image']}" alt="${hit.title}" />
                  </div>
                  `
                  : `
                  <div class="hit-placeholder-image-wrapper">
                    <div class="hit-placeholder-image">
                      <svg>
                        <use xlink:href="#ne-n"></use>
                      </svg>
                    </div>
                  </div>
                `
              }
                <h2 class="hit-title">
                  ${instantsearch.highlight({ attribute: 'title', hit })}
                </h2>
              </a>
            `;
            },
            /* eslint-enable */
          },
          transformItems: items => {
            // Hide pagination and results if no results
            this.toggleHide(this.results, items.length < 1);
            if (window.innerWidth <= 768 && items.length > 0) {
              this.toastActive();
            }
            return items;
          },
        }),

        // https://www.algolia.com/doc/api-reference/widgets/pagination/js/
        pagination({
          container: containers.pagination,
          showFirst: false,
          showLast: false,
          scrollTo: '.js--posts-search',
          templates: {
            previous: `
            <span class="visually-hidden">Previous page</span>
            <svg class="arrow prev">
              <use xlink:href="#icon-arrow"></use>
            </svg>
          `,
            next: `
            <span class="visually-hidden">Next page</span>
            <svg class="arrow next">
              <use xlink:href="#icon-arrow"></use>
            </svg>
          `,
          },
        }),

        // Semester
        refinementList({
          container: containers.refinementListSemester,
          attribute: 'semesters',
          operator: 'and',
          limit: 100, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.sortSemesterRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results or if department is specified
            const refList = document
              .querySelector(containers.refinementListSemester)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, items.length < 1);
            return items;
          },
        }),

        // Categories
        refinementList({
          container: containers.refinementListCategories,
          attribute: 'categories',
          operator: 'and',
          limit: 100, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.alphaSortRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results or if department is specified
            const refList = document
              .querySelector(containers.refinementListCategories)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, this.category || items.length < 1);
            return items;
          },
        }),

        // School or Department
        refinementList({
          container: containers.refinementListDepartments,
          attribute: 'departments',
          operator: 'and',
          limit: 100, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.alphaSortRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results or if department is specified
            const refList = document
              .querySelector(containers.refinementListDepartments)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, this.department || items.length < 1);
            return items;
          },
        }),

        // Research Centers
        refinementList({
          container: containers.refinementListResearchCenters,
          attribute: 'research_centers',
          operator: 'and',
          limit: 100, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.alphaSortRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results or if research center is specified
            const refList = document
              .querySelector(containers.refinementListResearchCenters)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, this.researchCenter || items.length < 1);
            return items;
          },
        }),

        // Topics
        refinementList({
          container: containers.refinementListTopics,
          attribute: 'topics',
          operator: 'and',
          limit: 100, // set to arbitrary large number to prevent default limit of 10
          sortBy: this.alphaSortRefinements,
          transformItems: items => {
            // Hide refinement list if there are no results
            const refList = document
              .querySelector(containers.refinementListTopics)
              .closest('.js--accordion');

            this.updateRefListClasses(items, refList);

            this.toggleHide(refList, items.length < 1);
            return items;
          },
        }),

        // https://www.algolia.com/doc/api-reference/widgets/clear-refinements/js/
        clearRefinements({
          container: containers.clearRefinements,
          templates: {
            resetLabel: 'Clear filters',
          },
        }),
      ]);
    }
  }

  static init() {
    new AlgoliaPostsSearch();
  }
}

export default AlgoliaPostsSearch;
